import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=72b79d14&"
import script from "./SendMessageModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports